// Absolute minimal invislbe widget with no functionality.
// WHY!?
// We can insert into placeholders, and overwrite, but can't delete. This will allow us to remove
// widgets we want to hide in existing detail views without necessarily pushing a new "real" on in.
/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        class DummyWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    return new DummyWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                window.setTimeout(this._presentInstances, 0);
            }
        }
        Widgets.DummyWidgetTypeClass = DummyWidgetTypeClass;
        class DummyWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this.presentInstance = () => {
                    this._type.instanceReady(this.getHandle());
                };
                // Hoping this takes effect after super/constructor
                config.CollapseState = 'Stealth';
            }
        }
        Widgets.DummyWidgetInstanceClass = DummyWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
